import { inject, Injectable } from '@angular/core';
import { CommonsService } from './commons.service';
import { MachineActivity, MachineActivityService } from 'src/api/generated';
import { BehaviorSubject, Observable } from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import { FilterDescriptor } from 'devextreme/data';
import { MachineInfoMainService } from './machine-info.service';


@Injectable({
  providedIn: 'root'
})
export class MachineActivityServicee {
  public dataSource: DataSource;
  public IsActive: boolean = false;

  protected _currentFilter: FilterDescriptor | Array<FilterDescriptor> = [];

  protected _currentRow: BehaviorSubject<MachineActivity | undefined> = new BehaviorSubject<MachineActivity | undefined>(undefined);
  public currentRow$: Observable<MachineActivity | undefined> = this._currentRow.asObservable();

  constructor(
    protected _commonSvc: CommonsService,
    protected _machineActivitySvc: MachineActivityService,
    protected _miSvc: MachineInfoMainService
  ) {
    this.dataSource = this._commonSvc.makeAsyncDataSource<MachineActivity, string, MachineActivityService>(this._machineActivitySvc, this._currentRow, this.filterForCurrentMachine.bind(this));
    this.Init();
  }

  protected Init(): void{
    this._miSvc.currentFilter$.subscribe({
      next: (f) => {
        this._currentFilter = f;
        if(this.IsActive){
          this.dataSource?.reload();
        }
      }
    });
  }

  private filterForCurrentMachine(filter: FilterDescriptor | Array<FilterDescriptor>): FilterDescriptor | Array<FilterDescriptor> {
    if (filter != null) {
      return [
        filter,
        "and",
        this._currentFilter
      ];
    } else {
      return this._currentFilter;
    }
  }

  public set CurrentRowId(id: string){
    this._miSvc.CurrentRowId = id;
  }

  public set CurrentRow(r: MachineActivity) {
    this._currentRow.next(r);
  }

  public reloadDataSource() {
    this.dataSource = this._commonSvc.makeAsyncDataSource<MachineActivity, string>(this._machineActivitySvc, this._currentRow, this.filterForCurrentMachine.bind(this));
  }

}
